var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"100%","src":"https://landings.bee-seller.com/6Uhrm2jGR4Uy9xIBZUiF5QxfsRg2?_gl=1*11e868n*_gcl_au*MTY3MTU5Mzc2Ni4xNjg3ODEyOTIw&_ga=2.3255344.1807819830.1688039042-961601568.1687812920"}})
}
var staticRenderFns = []

export { render, staticRenderFns }